import React from 'react';
import styled from 'styled-components';
import { defaultBreakpoints, getMediaQuery, Button } from '@ondeck/silkworm';
import NumberFormat from 'react-number-format';

export const mQ = getMediaQuery(defaultBreakpoints);

export const Input = styled.input`
  border: 1px solid #a9a9a9;
  border-radius: 0 6px 6px 0;
  display: block;
  padding-left: 10px;
  width: 100%;
`;

export const EmailInput = styled(Input)`
  font-size: var(--fontSizesSubtext);
  width: 100%;
`;

export const Grid = styled.div`
  background-color: #fff;
  display: grid;
  margin: 25px 25px 0;
  padding: 16px 0;
  ${mQ.md`
    padding: 0;
  `}
`;

export const Row = styled.div`
  display: flex;
  font-size: 12px;
  margin-bottom: 13px;
  padding: 0 16px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Row2 = styled.div`
  display: flex;
  font-size: 16px;
  margin: 0 40px;
  padding-top: 20px;
`;

export const NumWrapper = styled.div`
  color: #000082;
  margin-left: auto;
  text-align: right;
`;

export const PageInnerBox = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;

export const PageLayout = styled.div`
  width: 100%;
  ${mQ.md`
   width: 65%;
   padding: 25px;
  `}
`;

export const PartnerSupportLayout = styled.div`
  width: 100%;
  ${mQ.md`
   width: 35%;
  `}
`;

export const StyledButton = styled(Button)`
  margin: 18px 40px 38px;
  width: calc(100% - 80px);
`;

export const AmountWrapper = styled(NumberFormat)`
  color: #000082;
  margin-left: auto;
  text-align: right;
`;

export const Row3 = styled.div`
  display: flex;
  font-size: 16px;
  margin: 0 auto 8px;
`;

export const Box = styled.div`
  background-color: #f3f6fa;
  padding: 14px 0;
`;

export const StyledRow = styled(Row)`
  padding-top: 14px;
`;

export const OuterBox = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 6px #00000029;
  margin: 10px 10px 82px;
  padding: 32px;
  opacity: 1;
  ${mQ.md`
    margin: 0;
  `}
`;

export const BoxHeading = styled.div`
  color: #000000de;
  font-size: 25px;
  margin-bottom: 16px;
`;

export const Flex = styled.div`
  display: flex;
`;

interface AmtProps {
  value: number | string;
}
